webpackJsonp([28],{

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/messenger/index.js + 17 modules
var messenger = __webpack_require__(362);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/MessengerNew.vue





/* harmony default export */ var MessengerNew = ({
  components: {
    MessengerChat: messenger["a" /* MessengerChat */]
  },
  props: {
    _id: {
      type: String,
      required: true
    },
    scope: {
      type: String,
      default: 'user'
    },
    name: {
      type: String,
      default: ''
    },
    externalId: {
      type: Number,
      default: null
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    currentUser: 'skiliko/session/currentUser'
  }), {
    conversation: function conversation() {
      return {
        to: {
          _id: this._id,
          scope: this.scope,
          externalId: this.externalId,
          name: this.name
        },
        from: {
          _id: this.currentUser.chatable_id,
          scope: 'admin',
          externalId: this.currentUser,
          name: this.currentUser.nickname
        }
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37abaf02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MessengerNew.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('messenger-chat',{attrs:{"conversation":_vm.conversation}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_MessengerNew = (esExports);
// CONCATENATED MODULE: ./src/pages/MessengerNew.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MessengerNew,
  pages_MessengerNew,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_MessengerNew = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/28.52c7f8544ba906f26c23.js